import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/user';
import userConfirmationReducer from './reducers/userConfirmation';

export default configureStore({
  reducer: {
    user: userReducer,   
    userConfirmation: userConfirmationReducer,   
  },
})